import React from 'react';

export default function GreySeparator() {
    return <div className="checkout-grey-separator" />;
}
